import React from 'react';

const Home: React.FC = () => {
    return (
        <div style={{
            minHeight: 'calc(100vh - 100px)',
            background: 'white',
            color: '#4a306d',
            fontFamily: 'Arial, sans-serif',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div style={{
                textAlign: 'center',
                maxWidth: '800px',
                padding: '2rem'
            }}>
                <div style={{ marginBottom: '2rem' }}>
                    <img
                        src="/tdl-logo.jpg"
                        alt="TDL Coaching & Consulting"
                        style={{
                            height: '100px',
                            maxWidth: '500px',
                            width: 'auto',
                            objectFit: 'contain',
                            borderRadius: '8px'
                        }}
                    />
                </div>

                <h1 style={{
                    fontSize: '2.5rem',
                    marginBottom: '1rem',
                    color: '#4a306d'
                }}>
                    Welcome to TDL Coaching, Consulting & Training Academy, LLC
                </h1>

                <h2 style={{
                    fontSize: '1.5rem',
                    marginBottom: '1rem',
                    color: '#34a8a8',
                    fontWeight: 'bold'
                }}>
                    Empowering Healthcare Professionals with Knowledge and Skills for Success
                </h2>

                <p style={{
                    fontSize: '1.2rem',
                    lineHeight: '1.6',
                    opacity: 0.8,
                    marginBottom: '2rem',
                    textAlign: 'left'
                }}>
                    At TDL Coaching & Consultants, LLC, we specialize in offering high-quality, comprehensive healthcare training and certification
                    courses that equip professionals with the expertise to excel in their careers. Whether you're looking to start a new career in
                    healthcare, advance your current position, or stay up-to-date with industry standards, our courses are designed to meet your needs.
                </p>

                <div style={{ marginTop: '3rem', textAlign: 'left' }}>
                    <h2 style={{
                        fontSize: '2rem',
                        color: '#4a306d',
                        marginBottom: '2rem',
                        textAlign: 'center'
                    }}>
                        Our Services
                    </h2>

                    <div style={{ marginBottom: '2rem' }}>
                        <h3 style={{ color: '#34a8a8', marginBottom: '1rem', fontSize: '1.3rem' }}>
                            • Healthcare Certification Courses
                        </h3>
                        <p style={{ marginLeft: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
                            Gain the credentials you need to stand out in the competitive healthcare industry. We offer a range of certifications tailored to
                            various specialties, including medical billing and coding, clinical management, patient care, and more.
                        </p>
                    </div>

                    <div style={{ marginBottom: '2rem' }}>
                        <h3 style={{ color: '#34a8a8', marginBottom: '1rem', fontSize: '1.3rem' }}>
                            • Continuing Education
                        </h3>
                        <p style={{ marginLeft: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
                            Stay ahead of the curve with our continuing education programs. Designed for current healthcare professionals, our courses
                            keep you informed on the latest industry trends, regulatory updates, and best practices.
                        </p>
                    </div>

                    <div style={{ marginBottom: '2rem' }}>
                        <h3 style={{ color: '#34a8a8', marginBottom: '1rem', fontSize: '1.3rem' }}>
                            • Professional Coaching & Consulting
                        </h3>
                        <p style={{ marginLeft: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
                            Take your career to the next level with personalized coaching and strategic consulting. Our experts offer one-on-one sessions
                            to help you navigate challenges, optimize performance, and achieve your professional goals.
                        </p>
                    </div>
                </div>

                <div style={{ marginTop: '3rem', textAlign: 'left' }}>
                    <h2 style={{
                        fontSize: '2rem',
                        color: '#4a306d',
                        marginBottom: '2rem',
                        textAlign: 'center'
                    }}>
                        Why Choose TDL Coaching & Consultants, LLC?
                    </h2>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '2rem'
                    }}>
                        <div>
                            <h3 style={{ color: '#34a8a8', marginBottom: '1rem' }}>• Expert Instructors</h3>
                            <p style={{ opacity: 0.9, lineHeight: '1.6' }}>
                                Learn from experienced professionals who bring real-world insights and practical knowledge.
                            </p>
                        </div>

                        <div>
                            <h3 style={{ color: '#34a8a8', marginBottom: '1rem' }}>• Flexible Learning Options</h3>
                            <p style={{ opacity: 0.9, lineHeight: '1.6' }}>
                                With online and in-person courses, you can learn at your own pace and on your schedule.
                            </p>
                        </div>

                        <div>
                            <h3 style={{ color: '#34a8a8', marginBottom: '1rem' }}>• Comprehensive Support</h3>
                            <p style={{ opacity: 0.9, lineHeight: '1.6' }}>
                                We provide ongoing guidance, resources, and support to ensure your success, from enrollment to certification.
                            </p>
                        </div>

                        <div>
                            <h3 style={{ color: '#34a8a8', marginBottom: '1rem' }}>• Proven Results</h3>
                            <p style={{ opacity: 0.9, lineHeight: '1.6' }}>
                                Our students graduate with confidence, ready to take on new roles and responsibilities in the healthcare sector.
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: '3rem', textAlign: 'left' }}>
                    <h2 style={{
                        fontSize: '2rem',
                        color: '#4a306d',
                        marginBottom: '2rem',
                        textAlign: 'center'
                    }}>
                        Who We Serve
                    </h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6', opacity: 0.9, marginBottom: '1rem' }}>
                        We are dedicated to helping individuals at all stages of their healthcare careers:
                    </p>
                    <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9, paddingLeft: '2rem' }}>
                        <li>Aspiring healthcare professionals looking to enter the field</li>
                        <li>Current healthcare workers seeking to advance their skills and knowledge</li>
                        <li>Healthcare organizations looking to train and develop their staff</li>
                        <li>Individuals seeking career transitions into healthcare</li>
                    </ul>
                </div>

                <div style={{
                    marginTop: '3rem',
                    padding: '2rem',
                    background: 'rgba(52, 168, 168, 0.1)',
                    borderRadius: '15px',
                    textAlign: 'center'
                }}>
                    <h3 style={{ color: '#34a8a8', marginBottom: '1rem' }}>
                        Ready to Start Your Healthcare Journey?
                    </h3>
                    <p style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                        Explore our comprehensive courses and take the first step toward building expertise and advancing your career in healthcare.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Home;